import React from 'react';
import { Landmark, LandmarkExtendProps } from './Landmark';
import { ConcreteRoles } from './roles';

export interface MainProps extends LandmarkExtendProps {}

export const Main: React.FC<MainProps> = props => {
  return <Landmark role={ConcreteRoles.main} {...props} />;
};
